import compileSymbols from '~/utils/compileSymbols';

var types = [
  'ACTIVATE_SLEEVE_PRINT',
  'CHANGE_THRESHOLD',
  'CHANGE_VIEW',
  'CLEAR',
  'CLEAR_RECENT_UPLOADS',
  'DISABLE',
  'ICON_RENDERED',
  'REMOVE_RECENT_UPLOAD',
  'SET_DISABLE_ARROW_KEYS',
  'SET_LAB_BLANK_LOAD',
  'SHOW_DESIGN'
];

export default compileSymbols(types, 'canvas');
